import ServiceMember from "../ServiceMember";
import AuthServiceMember from "../AuthServiceMember.js"

const auth = {
    login(data) {
        return ServiceMember.post("/api/auth/login", data).then(res => res);
    },
    login_facebook(data) {
        return ServiceMember.post("/api/auth/login-facebook", data).then(res => res);
    },
    logout() {
        return AuthServiceMember.get(`api/auth/logout`).then(res => res);
    },
    register(data) {
        return ServiceMember.post(`api/auth/register`, data).then(res => res);
    },
    checkVerifyEmail(data) {
        let val = {'token' : data};
        return ServiceMember.post("/api/auth/check-verify-email", val).then(res => res);
    },
    forgetPassword(data) {
        return ServiceMember.post('api/auth/forget-password', data).then(res => res);
    },
    resetPassword(data) {
        return ServiceMember.post('api/auth/reset-password', data).then(res => res);
    },
    checkExpiresToken(profile_id) {
            return AuthServiceMember.get(`api/auth/check-expires-token`).then(res => res);
    },

};

export default auth;
